export default __webpack_public_path__ + "static/media/appiness.0c10ac93.svg";